import React,{ useState, useEffect, useRef } from 'react';
import { useNavigate  } from 'react-router-dom';
import { Input, Row, Col, Divider } from 'antd';

import { PlusOutlined, MinusOutlined, ArrowRightOutlined } from '@ant-design/icons';   

import BigCard from '../../../components/BigCard/BigCard'

import studiesEJCN from '../../../image/studies-EJCN-261x25.svg';
import studiesSTM from '../../../image/studies-STM-186x25.svg';
import studiesRedrxiv from '../../../image/studies-redrxiv-82x24.svg';
import studiesAgingCell from '../../../image/studies-agingCell-139x25.svg';
import studiesCRM from '../../../image/studies-CRM-190x25.svg';
import studiesCellpress from '../../../image/studies-cellpress-300x72.svg';
import studiesImmunity from '../../../image/studies-immunity-94x25.svg';
import studiesJamaNatwork from '../../../image/studies-jamaNatwork-123x25.svg';
import studiesNatureAging from '../../../image/studies-natureAging-96x24.svg';
import studiesNatureMedicine from '../../../image/studies-natureMedicine-122x25.svg';
import studiesNatureMetabolism from '../../../image/studies-natureMetabolism-142x25.svg';
import studiesScientificReports from '../../../image/studies-scientificReports-139x25.svg';
import studiesAnalyticalChemistry from '../../../image/studies-AnalyticalChemistry.png';
import studiesChemistryEurope from '../../../image/studies-ChemistryEurope.webp';

import studiesGPB from '../../../image/studies-GPB.svg';
import studiesScienceDirect from '../../../image/studies-ScienceDirect.svg';
import studiesPNAS from '../../../image/studies-PNAS.svg';
import studiesAdvanced from '../../../image/studies-advanced.webp';

import studiesLifeMedicine from '../../../image/studies-LifeMedicine.svg';
import studiesNatureCommunications from '../../../image/studies-NatureCommunications.svg';
import studiesPLOS from '../../../image/studies-PLOS.png';
import studiesSpringerNature from '../../../image/studies-SpringerNature.svg';
import studiesThe_FEBS_Journal from '../../../image/studies-The_FEBS_Journal.png';
import studiesAJHG from '../../../image/studies-AJHG.svg';
import studiesAnnualreviews from '../../../image/studies-Annualreviews.png';
import studiesBRAIN from '../../../image/studies-BRAIN.svg';
import studiesGBE from '../../../image/studies-GBE.svg';
import studiesIJMS from '../../../image/studies-IJMS.webp';
import studiesEpigenomics from '../../../image/studies-Epigenomics.png';


import { getStudiesList } from '../../../api/studies'

import './studies.less'

const Studies = () =>{
  const navigate = useNavigate();
  
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    getStudiesListFn()
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);

    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  const journalList = {
    EJCN: studiesEJCN,
    STM: studiesSTM,
    Redrxiv: studiesRedrxiv,
    AgingCell: studiesAgingCell,
    CRM: studiesCRM,
    Cellpress: studiesCellpress,
    Immunity: studiesImmunity,
    JamaNatwork: studiesJamaNatwork,
    NatureAging: studiesNatureAging,
    NatureMedicine: studiesNatureMedicine,
    NatureMetabolism: studiesNatureMetabolism,
    ScientificReports: studiesScientificReports,
    AnalyticalChemistry: studiesAnalyticalChemistry,
    ChemistryEurope: studiesChemistryEurope,

    GPB: studiesGPB,
    ScienceDirect: studiesScienceDirect,
    PNAS: studiesPNAS,
    Advanced: studiesAdvanced,

    LifeMedicine: studiesLifeMedicine,
    NatureCommunications: studiesNatureCommunications,
    PLOS: studiesPLOS,
    SpringerNature: studiesSpringerNature,
    The_FEBS_Journal: studiesThe_FEBS_Journal,
    AJHG: studiesAJHG,
    Annualreviews: studiesAnnualreviews,
    BRAIN: studiesBRAIN,
    GBE: studiesGBE,
    IJMS: studiesIJMS,
    Epigenomics: studiesEpigenomics
  }
  
  
  
  
  
  
  
  
  
  
  
  const [listData, setListData] = useState([])

  let bigCardData1 = {
    type: 'bgCard',
    bgImg: require('../../../image/bigCardBg2-2640x1200.png'),
    textWidth: '30%',
    textPosition: 'right',
    title: '15 years of research in healthy aging and longevity',
    description: 'Mitopure is the first and only clinically tested Urolithin A supplement. Our MDs and PhDs pioneered the first clinical studies with Urolithin A in humans.',
    btnConfig:{
      text: 'Discover our science',
      link: ''
    }
  }

  // 获取论文列表
  const getStudiesListFn = async () =>{
    let update = {
      page: 1,
      limit: 1000
    }
    let res = await getStudiesList(update)
    console.log('StudiesList', res?.data)
    if(res?.msg === 'success'){
      let resData = res.data.map((e,i)=>{
        const now = new Date(e.publishedTime);
        const Y = now.getFullYear();
        const M = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
        const D = String(now.getDate()).padStart(2, '0');

        return ({
          time: e.publishedTime? `${Y}-${M}-${D}`:'', 
          title: e.title,
          detail: e.excerpt,
          journal: e.journal,
          blogLink: e.blogUrl?.includes("http")? e.blogUrl:'',
          paperLink: e.paperUrl?.includes("http")? e.paperUrl:'',
          state: false,
          studiesType: e.studiesType
        })
      })
      setListData(()=> resData)
    }
  }


  // 修改列表状态
  const setListState = (i)=>{
    let copyData = JSON.parse(JSON.stringify(listData))
    copyData[i].state = !copyData[i].state
    setListData(()=> copyData)
  }


  if(width > 770){
    return (
      <div className="studies-page" style={{textAlign: 'left'}}>
        <div className="studies-title">
          我们的研究
        </div>

        <div style={{width: '100%', borderTop:'1px solid #000'}}>
          <div style={{width: '100%', maxWidth: 1540, margin:'0 auto', padding:'0 50px'}}>
            <div className="studies-detail">
              我们的核心是反对伪科学。15年来，我们率先在衰老和尿锂素A（Mitopure）方面取得了有意义的科学发现，并通过在高影响力、同行评审的期刊上发表文章，使其受到科学界的审查。我们致力于严谨的研究，这使我们有别于依赖炒作和未经证实的说法的膳食补充剂和护肤公司。
            </div>

            {/* 临床研究 */}
            <div className="list-box">
              <div className="list-title">临床研究</div>
              <div className="list-detail">对人类进行的研究，旨在评估新疗法或干预措施的安全性、有效性和最佳剂量，通常分多个阶段进行。</div>
              <div className="list">
                <Row gutter={[16, 24]} className="list-header">
                  <Col span={6}>发表日期</Col>
                  <Col span={12}>标题</Col>
                  <Col span={6}>科学期刊</Col>
                </Row>
                {listData.map((e,i)=>{
                  if(e.studiesType === "1"){
                    return (
                      <Row key={i} gutter={[16, 24]} className="list-item" onClick={()=> setListState(i)}>
                        <Col span={6}>{e.time? e.time: <span style={{color:'#878780'}}>ONGOING</span>}</Col>
                        <Col span={12} className="list-item-title">
                          {e.title}
                          {e.state? 
                            <div className="list-item-detail">
                              <div>{e.detail}</div>
                              <div>
                                {e.blogLink? <button className="readButton" onClick={()=> navigate(btnConfig.link)}>
                                  READ BLOG <ArrowRightOutlined style={{marginLeft:20}}/>
                                </button>:''}
                                {e.paperLink? <button className="readButton" onClick={()=> navigate(btnConfig.link)}>
                                  READ PAPER <ArrowRightOutlined style={{marginLeft:20}}/>
                                </button>:''}
                              </div>
                            </div>
                            :
                            ''
                          }
                          
                        </Col>
                        <Col span={6} style={{display:'flex', justifyContent: 'space-between',alignItems: 'flex-start'}}>
                          <div className="journal-box">
                            {e.journal?  
                              <img className="journal-img" src={journalList[e.journal]} alt="" />
                              : 
                              <span style={{color:'#878780'}}>Not yet published</span>
                            }
                          </div>
                          {!e.state? 
                            <PlusOutlined style={{fontSize: 24}}/>
                            :
                            <MinusOutlined style={{fontSize: 24}}/>
                          }
                          
                        </Col>
                      </Row>
                    )
                  }
                })}
              </div>
            </div>

            {/* 临床前研究 */}
            <div className="list-box" style={{marginTop: 50}}>
              <div className="list-title">临床前研究</div>
              <div className="list-detail">在人体试验之前，为评估新疗法的安全性、有效性和机制而进行的实验室实验。</div>
              <div className="list">
                <Row gutter={[16, 24]} className="list-header">
                  <Col span={6}>发表日期</Col>
                  <Col span={12}>标题</Col>
                  <Col span={6}>科学期刊</Col>
                </Row>
                {listData.map((e,i)=>{
                  if(e.studiesType === "2"){

                    return (
                      <Row key={i} gutter={[16, 24]} className="list-item" onClick={()=> setListState(i)}>
                        <Col span={6}>{e.time? e.time: <span style={{color:'#878780'}}>ONGOING</span>}</Col>
                        <Col span={12} className="list-item-title">
                          {e.title}
                          {e.state? 
                            <div className="list-item-detail">
                              <div>{e.detail}</div>
                              <div>
                                {e.blogLink? <button className="readButton" onClick={()=> navigate(btnConfig.link)}>
                                  READ BLOG <ArrowRightOutlined style={{marginLeft:20}}/>
                                </button>:''}
                                {e.paperLink? <button className="readButton" onClick={()=> navigate(btnConfig.link)}>
                                  READ PAPER <ArrowRightOutlined style={{marginLeft:20}}/>
                                </button>:''}
                              </div>
                            </div>
                            :
                            ''
                          }
                          
                        </Col>
                        <Col span={6} style={{display:'flex', justifyContent: 'space-between',alignItems: 'flex-start'}}>
                          <div className="journal-box">
                            {e.journal?  
                              <img className="journal-img" src={journalList[e.journal]} alt="" />
                              : 
                              <span style={{color:'#878780'}}>Not yet published</span>
                            }
                          </div>
                          {!e.state? 
                            <PlusOutlined style={{fontSize: 24}}/>
                            :
                            <MinusOutlined style={{fontSize: 24}}/>
                          }
                          
                        </Col>
                      </Row>
                    )
                  }
                })}
              </div>
            </div>
          </div>
        </div>
  
        <div style={{width: 'calc(100% - 20px)', margin: '0 auto'}}>
          <BigCard bigCardData={bigCardData1}/>
        </div>
      </div>
    )
  }else{
    return (
      <div className="studies-page" style={{textAlign: 'left'}}>
        <div className="studies-title-phone">
          我们的研究
        </div>
        
        <div style={{width: '100%', borderTop:'1px solid #000'}}>
          <div style={{width: '100%', maxWidth: 1540, margin:'0 auto', padding:'0 25px'}}>
            <div className="studies-detail-phone">
            我们的核心是反对伪科学。15年来，我们率先在衰老和尿锂素A（Mitopure）方面取得了有意义的科学发现，并通过在高影响力、同行评审的期刊上发表文章，使其受到科学界的审查。我们致力于严谨的研究，这使我们有别于依赖炒作和未经证实的说法的膳食补充剂和护肤公司。
            </div>

            {/* 临床研究 */}
            <div className="list-box">
              <div className="list-title">临床研究</div>
              <div className="list-detail" style={{width: '100%'}}>对人类进行的研究，旨在评估新疗法或干预措施的安全性、有效性和最佳剂量，通常分多个阶段进行。</div>
              <div className="list">
                <Row gutter={[16, 24]} className="list-header">
                  <Col span={6}>发表日期</Col>
                </Row>
                {listData.map((e,i)=>{
                  if(e.studiesType === "1"){
                    return (
                      <Row key={i} gutter={[16, 0]} className="list-item" onClick={()=> setListState(i)}>
                        <Col span={24} style={{display:'flex', justifyContent: 'space-between',alignItems: 'flex-start'}}>
                          {e.time? e.time: <span style={{color:'#878780'}}>ONGOING</span>}
                          {!e.state? 
                            <PlusOutlined style={{fontSize: 24}}/>
                            :
                            <MinusOutlined style={{fontSize: 24}}/>
                          }
                        </Col>
                        <Col span={24} style={{margin:'24px 0 16px',display:'flex', justifyContent: 'space-between',alignItems: 'flex-start'}}>
                          {e.journal?  
                            <img style={{height: 24}} src={journalList[e.journal]} alt="" />
                            : 
                            <span style={{color:'#878780'}}>Not yet published</span>
                          }
                        </Col>
                        <Col span={24} className="list-item-title">
                          {e.title}
                          {e.state? 
                            <div className="list-item-detail">
                              <div>{e.detail}</div>
                              <div>
                                {e.blogLink? <button className="readButton" onClick={()=> navigate(e.blogLink)}>
                                  阅读博客 <ArrowRightOutlined style={{marginLeft:20}}/>
                                </button>:''}
                                {e.paperLink? <button className="readButton" onClick={()=> navigate(e.paperLink)}>
                                  阅读期刊 <ArrowRightOutlined style={{marginLeft:20}}/>
                                </button>:''}
                              </div>
                            </div>
                            :
                            ''
                          }
                          
                        </Col>
                      </Row>
                    )
                  }
                })}
              </div>
            </div>

            {/* 临床前研究 */}
            <div className="list-box" style={{marginTop: 50}}>
              <div className="list-title">临床前研究</div>
              <div className="list-detail" style={{width: '100%'}}>在人体试验之前，为评估新疗法的安全性、有效性和机制而进行的实验室实验。</div>
              <div className="list">
                <Row gutter={[16, 24]} className="list-header">
                  <Col span={6}>发表日期</Col>
                </Row>
                {listData.map((e,i)=>{
                  if(e.studiesType === "1"){
                    return (
                      <Row key={i} gutter={[16, 0]} className="list-item" onClick={()=> setListState(i)}>
                        <Col span={24} style={{display:'flex', justifyContent: 'space-between',alignItems: 'flex-start'}}>
                          {e.time? e.time: <span style={{color:'#878780'}}>ONGOING</span>}
                          {!e.state? 
                            <PlusOutlined style={{fontSize: 24}}/>
                            :
                            <MinusOutlined style={{fontSize: 24}}/>
                          }
                        </Col>
                        <Col span={24} style={{margin:'24px 0 16px',display:'flex', justifyContent: 'space-between',alignItems: 'flex-start'}}>
                          {e.journal?  
                            <img style={{height: 24}} src={journalList[e.journal]} alt="" />
                            : 
                            <span style={{color:'#878780'}}>Not yet published</span>
                          }
                        </Col>
                        <Col span={24} className="list-item-title">
                          {e.title}
                          {e.state? 
                            <div className="list-item-detail">
                              <div>{e.detail}</div>
                              <div>
                                {e.blogLink? <button className="readButton" onClick={()=> navigate(btnConfig.link)}>
                                  阅读博客 <ArrowRightOutlined style={{marginLeft:20}}/>
                                </button>:''}
                                {e.paperLink? <button className="readButton" onClick={()=> navigate(btnConfig.link)}>
                                  阅读期刊 <ArrowRightOutlined style={{marginLeft:20}}/>
                                </button>:''}
                              </div>
                            </div>
                            :
                            ''
                          }
                          
                        </Col>
                      </Row>
                    )
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Studies